// IMPORTANT: Build gql after ANY changes to queries (client OR api)

import { graphql } from '@/client/services/api/graphql/gql';

export const createWorkflowNotificationMutation: any = graphql(`
  mutation CreateNotification($notification: NotificationCreateInput!) {
    createNotification(create: $notification) {
      id
      __typename
    }
  }
`);

export const updateWorkflowNotificationMutation: any = graphql(`
  mutation UpdateNotification($id: String!, $notification: NotificationUpdateInput!) {
    updateNotification(id: $id, update: $notification) {
      id
      __typename
    }
  }
`);
